
import React, { useEffect } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import CountUp from "react-countup";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breadcrumbs from "../common/Breadcrumbs";
import Aos from "aos";

const AboutUs = () => {
    
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  return (
    <>
      <style>
        {`
        .glass-card {
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.07);
            backdrop-filter: blur(4px);
            -webkit-backdrop-filter: blur(4px);
            border-radius: 16px;
            border: 1px solid rgba(255, 255, 255, 0.18);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .glass-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 40px 0 rgba(31, 38, 135, 0.15);
        }
        .partner-logo-img {
            max-height: 50px;
            width: auto;
            max-width: 100%;
            transition: filter 0.3s;
            filter: grayscale(100%);
            opacity: 0.7;
        }
        .partner-card:hover .partner-logo-img {
            filter: grayscale(0%);
            opacity: 1;
        }
        .text-gold {
            color: #c5a059;
        }
        .about-exp {
            background: rgba(30, 30, 30, 0.95) !important;
            position: absolute !important;
            left: 0 !important; /* Align to left edge of container */
            top: 50% !important;
            transform: translateY(-50%) !important;
            width: 60px !important;
            height: 110% !important; /* Restrict height to 80% of image */
            padding: 0 !important;
            border-radius: 30px !important;
            z-index: 10;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 5px 0 25px rgba(0,0,0,0.2) !important;
            border: 1px solid rgba(197, 160, 89, 0.3);
            backdrop-filter: blur(5px);
        }
        .about-exp span {
            margin: 0 !important;
            transform: rotate(-90deg) !important;
            display: block !important;
            color: #c5a059 !important;
            font-weight: 700;
            font-size: 18px !important;
            letter-spacing: 3px;
            text-transform: uppercase;
            white-space: nowrap;
        }
        .about-img {
            padding-left: 40px !important; /* Make room for the badge */
        }
        .abt-img {
            border-radius: 20px;
            overflow: hidden;
        }
        .about-img {
            padding-left: 0 !important; /* Remove legacy padding that made room for the side bar */
        }
        .abt-img {
            padding: 0 !important; /* Reset legacy padding */
        }
        `}
      </style>
      
      {/* Breadscrumb Section */}
      <Breadcrumbs title="Despre Noi" subtitle="AD SHOWROOM" />
      {/* /Breadscrumb Section */}
      
      {/* About */}
      <section className="section about-sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="about-img_wrapper position-relative">
                <div className="about-img">
                    <div className="about-exp shadow-lg text-gold">
                        <span>Experiență & Incredere</span>
                    </div>
                    <div className="abt-img rounded-4 overflow-hidden shadow-lg">
                    <ImageWithBasePath
                        src="assets/img/about-us.png"
                        className="img-fluid"
                        alt="Despre AD SHOWROOM"
                    />
                    </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <div className="about-content ps-lg-5">
                <h6 className="text-gold letter-spacing-2 text-uppercase font-weight-bold mb-3">Povestea AD SHOWROOM</h6>
                <h2 className="display-6 font-weight-bold mb-4">Standarde Premium în Sectorul 3</h2>
                <p className="lead text-muted mb-4">
                  Situat în inima Bucureștiului, AD SHOWROOM redefinitște experiența achiziției auto. 
                  Nu vindem doar mașini, ci oferim certitudinea calității.
                </p>
                <p className="mb-4 text-muted">
                  Fiecare autoturism din stocul nostru este selecționat riguros. 
                  Colaborăm exclusiv cu parteneri de top pentru a garanta proveniența și istoricul fiecărui vehicul. 
                  Transparența nu este o opțiune pentru noi, este standardul.
                </p>
                
                <div className="row mt-5">
                  <div className="col-md-6 mb-3">
                    <div className="d-flex align-items-center mb-3">
                         <div className="icon-box bg-light rounded-circle p-2 me-3 text-gold">
                            <i className="fa-solid fa-medal fa-lg"></i>
                         </div>
                         <span className="font-weight-bold">Calitate Certificată</span>
                    </div>
                    <div className="d-flex align-items-center">
                         <div className="icon-box bg-light rounded-circle p-2 me-3 text-gold">
                            <i className="fa-solid fa-shield-halved fa-lg"></i>
                         </div>
                         <span className="font-weight-bold">Garanție Inclusă</span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex align-items-center mb-3">
                         <div className="icon-box bg-light rounded-circle p-2 me-3 text-gold">
                            <i className="fa-solid fa-gauge-high fa-lg"></i>
                         </div>
                         <span className="font-weight-bold">Km Reali Garantati</span>
                    </div>
                    <div className="d-flex align-items-center">
                         <div className="icon-box bg-light rounded-circle p-2 me-3 text-gold">
                            <i className="fa-solid fa-handshake fa-lg"></i>
                         </div>
                         <span className="font-weight-bold">Consultanță Premium</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /About */}

      {/* Partners Section - Premium Look */}
      <section className="section bg-light position-relative overflow-hidden" style={{ padding: '80px 0'}}>
         <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="section-heading text-center mb-5" data-aos="fade-up">
                <h6 className="text-gold text-uppercase letter-spacing-2 mb-2">Parteneri De Încredere</h6>
                <h2 className="mb-3">Transparență și Proveniență Sigură</h2>
                <div className="divider mx-auto bg-gold" style={{ width: '60px', height: '3px', background: '#c5a059' }}></div>
            </div>
            
            <div className="row justify-content-center">
                {/* OpenLane */}
                <div className="col-lg-5 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="100">
                    <div className="glass-card partner-card p-5 h-100 text-center">
                        <div className="logo-container mb-4 d-flex align-items-center justify-content-center" style={{ height: '70px' }}>
                             {/* Use official SVG URL or high quality fallback */}
                            <img 
                                src="https://corporate.openlane.com/wp-content/uploads/2023/05/OPENLANE-Logo.png" 
                                alt="OpenLane" 
                                className="partner-logo-img"
                                style={{ maxHeight: '150px' }}
                            />
                        </div>
                        <h4 className="mb-3">OpenLane</h4>
                        <p className="text small px-3">
                            Platformă europeană de licitații premium. Sursa noastră principală pentru autoturisme verificate direct de la producători și flote corporative.
                        </p>
                    </div>
                </div>

                {/* Autovit */}
                <div className="col-lg-5 col-md-6 mb-4" data-aos="fade-up" data-aos-delay="200">
                    <div className="glass-card partner-card p-5 h-100 text-center">
                        <div className="logo-container mb-4 d-flex align-items-center justify-content-center" style={{ height: '70px' }}>
                             <img 
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAAEwi3SGivInZZZsrELmEM4x0yQKKXOqZuw&s" 
                                alt="Autovit.ro" 
                                className="partner-logo-img"
                                style={{ maxHeight: '45px' }}
                             />
                        </div>
                        <h4 className="mb-3">Autovit.ro</h4>
                        <p className="text small px-3">
                             Partener strategic pentru vânzare. Transparența noastră este confirmată de statutul de Dealer Verificat pe cea mai mare platformă auto din România.
                        </p>
                    </div>
                </div>
            </div>
         </div>
      </section>

      {/* Why Choose Us - Redesigned */}
      <section className="section why-choose pb-0">
        <div className="choose-left">
          <ImageWithBasePath
            src="assets/img/bg/choose-left.png"
            className="img-fluid"
            alt="De ce să ne alegeți"
          />
        </div>
        <div className="container">
          <div className="section-heading" data-aos="fade-down">
            <h2 className="text-center mb-5">De ce clienții aleg AD SHOWROOM</h2>
          </div>
          
          <div className="why-choose-group">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-up">
                <div className="card flex-fill border-0 shadow-sm glass-card">
                  <div className="card-body p-4">
                    <div className="choose-img bg-dark text-white d-flex align-items-center justify-content-center mb-4" style={{ width: '60px', height: '60px', borderRadius: '12px' }}>
                      <i className="fa-solid fa-file-contract fa-xl"></i>
                    </div>
                    <div className="choose-content">
                      <h4 className="mb-3">Transparență 100%</h4>
                      <p className="text-muted">
                        Nu ascundem nimic. Oferim rapoarte complete, istoric de service și acceptăm orice test autorizat.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-up" data-aos-delay="100">
                <div className="card flex-fill border-0 shadow-sm glass-card">
                  <div className="card-body p-4">
                    <div className="choose-img bg-gold text-white d-flex align-items-center justify-content-center mb-4" style={{ width: '60px', height: '60px', borderRadius: '12px', background: '#c5a059' }}>
                      <i className="fa-solid fa-location-dot fa-xl"></i>
                    </div>
                    <div className="choose-content">
                      <h4 className="mb-3">Sector 3</h4>
                      <p className="text-muted">
                        Te așteptăm într-o locație centrală unde poți analiza mașina dorită pe îndelete.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-12 d-flex" data-aos="fade-up" data-aos-delay="200">
                <div className="card flex-fill border-0 shadow-sm glass-card">
                  <div className="card-body p-4">
                    <div className="choose-img bg-dark text-white d-flex align-items-center justify-content-center mb-4" style={{ width: '60px', height: '60px', borderRadius: '12px' }}>
                      <i className="fa-solid fa-star fa-xl"></i>
                    </div>
                    <div className="choose-content">
                      <h4 className="mb-3">Servicii Complete</h4>
                      <p className="text-muted">
                        De la finanțare rapidă la înmatriculare, ne ocupăm de tot procesul pentru ca tu să te bucuri de drum.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
       {/* Call to Action Premium */}
       <section className="section-cta py-5 text-white text-center position-relative" style={{ background: '#111'}}>
            <div className="container position-relative" style={{ zIndex: 2 }}>
                <h2 className="mb-4 display-5" style={{ fontWeight: 300, color: '#fff' }} data-aos="fade-up">Experiența <strong className="text-gold" style={{ fontWeight: 700 }}>AD SHOWROOM</strong></h2>
                <p className="lead mb-5 opacity-75" data-aos="fade-up" data-aos-delay="100">Programați o vizionare astăzi și convingeți-vă singuri.</p>
                <a href="/listing-grid" className="btn btn-outline-light btn-lg px-5 py-3 rounded-0" style={{ letterSpacing: '2px', textTransform: 'uppercase', fontSize: '14px' }}>Vezi Oferta</a>
            </div>
       </section>
    </>
  );
};

export default AboutUs;
